import * as React from "react";
import { forwardRef } from "react";
const SvgUnchecked = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 12, height: 12, rx: 6, fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M2.99979 5.40002L8.9998 5.40002C9.33116 5.40002 9.59979 5.66864 9.59979 6.00001C9.5998 6.33138 9.33117 6.60001 8.99979 6.60001L2.99979 6.6C2.66843 6.6 2.3998 6.33138 2.3998 6.00002C2.39979 5.66865 2.66842 5.40002 2.99979 5.40002Z", fill: "white" }));
const ForwardRef = forwardRef(SvgUnchecked);
export default ForwardRef;
